export default __webpack_public_path__ + "static/media/brauP.0b787322.png";